import { BigNumber } from 'bignumber.js';

const division = (a: number, b: number): BigNumber => {
  const aBig = new BigNumber(a);
  const bBig = new BigNumber(b);
  return aBig.div(bBig);
};

export { division };
